export default "__VITE_ASSET__BQrYcRY2__"